import FeedLink from './FeedLink';

export default FeedLink;
